import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import '~/js/sections/weddings/includes/stickyNav';
// import '~/js/sections/weddings/includes/stickyNav.js';

// //////////////Sticky Nav//////////////////////
// Variable Declaration
// const resortMenu = document.getElementById('resort-menu');
// const toggleButton = document.getElementById('resort-menu-click');
// const isFixedNav = resortMenu.classList.contains('fixed-resort-menu');
// let waypoint;

// // Internals Variables
// const internals = {
//   options: {
//     element: resortMenu,
//     offset: 0,
//     stuckClass: 'stuck',
//   },
// };

// // Sticky Nav
// if (!isFixedNav) {
//   waypoint = new window.Waypoint.Sticky(internals.options);
// }

// // Toggle Sticky Nav
// toggleButton.addEventListener('click', () =>
//   resortMenu.classList.toggle('open')
// );
// document.body.addEventListener('click', (event) => {
//   if (
//     $(event.target).parents('#resort-menu').length <= 0 &&
//         resortMenu.classList.contains('open')
//   ) {
//     resortMenu.classList.remove('open');
//   }
// });

// const stickyNav = _globalUtils.debounce(() => {
//   if (window.pageYOffset <= waypoint.waypoint.triggerPoint) {
//     if (window.innerWidth > 767) {
//       if (resortMenu.classList.contains('stuck')) {
//         resortMenu.classList.remove('stuck');
//       }
//     }
//   }
// }, 300);

// window.addEventListener('resize', stickyNav);

// //////////////End of Sticky Nav//////////////////////


ReactDOM.render(
  <CustomRecaptcha wrapperClassName="xs-12 lg-12" />,
  document.getElementById('google-recaptcha')
);

const countryPhoneCodes = require('~/js/modules/countryCallingCodes');

const countryCodes = countryPhoneCodes.countryCodes.sort((a, b) => {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
}).map(element => `(${element.dial_code}) - ${element.name}`);
const selectElement = document.getElementById('areaCode');

countryCodes.forEach((element) => {
  const dialCode = element.split(' -');

  selectElement.add(new Option(element, dialCode[0]));
});

// Form validations
import '~/js/modules/fend';

const $inquiryForm = $('.inquiry-registration-form');
const $submitButton = $('.form-submit-button');
const $suscribeCheckbox = $('#subscribe');
const $suscribeHidden = $('#subscribeHidden');

$submitButton.click(() => {
  $('[name=phoneNumber]').val($('[name=mobileNumber]').val());

  if ($suscribeCheckbox.is(':checked') === true) {
    $suscribeHidden.prop('disabled', true);
  } else {
    $suscribeHidden.prop('disabled', false);
  }
});

const $test = $('#termsAndConditionsAccepted');
const $label = $('#label_conditions');

$test.click(() => {
  if ($test.is(':checked') === true) {
    $label.addClass('active');
  } else {
    $label.removeClass('active');
  }
});

$inquiryForm.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    phoneNumber: 'number',
  },
  isMultiPart: false,
});


// import '~/js/sections/weddings/includes/stickyNav';
// // create new array for countries and appending a new object that represents default value
// /* eslint-disable */
// const countries = [
//     {
//         name: 'Select a Country',
//         id: '',
//         regionCode: '',
//         code: ''
//     },
//     ...window.beaches_app.page.countries
// ];

// const callingCodesObj = require('~/js/modules/countryCallingCodes');

// // create new array for states and appending a new object that represents default value
// const states = [...window.beaches_app.page.states];

// const beachesResorts = window.beaches_app.page.resorts;

// // import CustomDatepicker from '~/js/components/form-controls/CustomDatepicker';
// import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
// import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
// import CardContainer from '~/js/components/weddings/CardContainer';
// import FromTo from '~/js/components/form-controls/FromTo';

// ReactDOM.render(
//     <CardContainer resorts={beachesResorts} />,
//     document.getElementById('cards-wrapper')
// );

// ReactDOM.render(
//     <FromTo
//         dateFromName="arrivalDate"
//         dateToName="weddingDate"
//         enabledLabels
//         fromLabelText="Estimated Arrival Date:"
//         toLabelText="Preferred Wedding Date:"
//         fromPlaceHolder="dd/mm/yyyy"
//         toPlaceHolder="dd/mm/yyyy"
//         wrapperClassNameFrom="lg-7"
//         wrapperClassNameTo="lg-7"
//         isRequired
//         showTo={false}
//         fromNextDay
//     />,
//     document.getElementById('estimated-date')
// );

// ReactDOM.render(
//     <CountryStateSelector
//         countries={countries}
//         states={states}
//         countryName="country"
//         stateName="state"
//         stateLabelWrapper="lg-5"
//         stateInputWrapper="lg-7"
//         countryLabelWrapper="lg-5"
//         countryInputWrapper="lg-7"
//     />,
//     document.getElementById('country-state-selector')
// );

// ReactDOM.render(
//     <CustomRecaptcha wrapperClassName="xs-12" />,
//     document.getElementById('google-recaptcha')
// );

// // form validations
// import '~/js/modules/fend';

// const $checkboxInput = $('.checkbox-opt.resort-opt');
// const $resortCheckbox = $('.resort-opt');
// const $landlineNumber = $('#landLineNumber');
// const $mobileNumber = $('#mobileNumber');
// const $submitButton = $('.form-submit-button');
// const $resortsSection = $('.resorts-section');
// const $notSureCheckbox = $('#notSure');
// const $resortsCheckboxes = $('#inquiry-form input[type=checkbox].resort-opt');
// const $termConfirmation = $('#termsAndConditionsAccepted');
// const $termsLabel = $('.js-terms-label');
// const $validPhone = $('#contactNumberValid');
// let termsErrors = 0;

// $('.inquiry-form').fend({
//     rules: {
//         brideFirstName: 'lettersOnly',
//         brideLastName: 'lettersOnly',
//         groomFirstName: 'lettersOnly',
//         groomLastName: 'lettersOnly',
//         city: 'lettersOnly'
//     }
// });

// $landlineNumber.change(function validateNumber() {
//     if (this.value) {
//         $validPhone.removeAttr('required');
//         $mobileNumber.trigger('blur');
//         $validPhone.val($landlineNumber.val());
//         $validPhone.trigger('blur');
//     } else {
//         if ($mobileNumber.val()) {
//             $validPhone.removeAttr('required');
//             $validPhone.val($mobileNumber.val());
//         } else {
//             $validPhone.val('');
//         }
//         $validPhone.trigger('blur');
//     }
// });

// $mobileNumber.change(function validateNumber() {
//     if (this.value) {
//         $validPhone.removeAttr('required');
//         $landlineNumber.trigger('blur');
//         $validPhone.val($mobileNumber.val());
//         $validPhone.trigger('blur');
//     } else {
//         if ($landlineNumber.val()) {
//             $validPhone.removeAttr('required');
//             $validPhone.val($landlineNumber.val());
//         } else {
//             $validPhone.val('');
//         }
//         $validPhone.trigger('blur');
//     }
// });

// $resortCheckbox.change(() => {
//     $resortsCheckboxes.each(function validateEachCheckbox() {
//         if ($(this).is(':checked') === true) {
//             $submitButton.prop('disabled', false);
//             $notSureCheckbox.prop('checked', false);
//             $('#resorts-error').remove();
//         }
//     });
// });

// $notSureCheckbox.change(() => {
//     if ($notSureCheckbox.is(':checked') === true) {
//         $resortCheckbox.not(this).prop('checked', false);
//         $submitButton.prop('disabled', false);
//         $('#resorts-error').remove();
//     }
// });

// $termConfirmation.change(() => {
//     if ($termConfirmation.is(':checked') === true) {
//         termsErrors = 0;
//         $submitButton.prop('disabled', false);
//         $('#termConfirmation-error').remove();
//     }
// });

// $submitButton.click(() => {
//     let resortsErrors = 0;
//     const errorLabels = $('.resort-error').length;

//     $resortsCheckboxes.each(function validateEachCheckbox() {
//         //  at least one resort option or not sure option must be selected to be ok.
//         if (
//             $(this).is(':checked') !== true &&
//             $notSureCheckbox.is(':checked') !== true
//         ) {
//             resortsErrors++;
//         } else {
//             resortsErrors = 0;

//             return false;
//         }

//         return true;
//     });

//     if (resortsErrors > 0) {
//         errorLabels < 1
//             ? $resortsSection.prepend(
//                   '<label id="resorts-error" class="resort-error has-error empty-field-error arial font-bold"><span class="show">This field is required.</span> Please choose at least one resort.</label>'
//               )
//             : '';
//         $submitButton.prop('disabled', true);
//         $('html, body').animate(
//             {
//                 scrollTop: $resortsSection.position().top
//             },
//             900
//         );
//     }

//     // validate the terms and conditions checkbox.
//     if ($termConfirmation.is(':checked') !== true) {
//         termsErrors++;
//         termsErrors === 1
//             ? $termsLabel.prepend(
//                   '<label id="termConfirmation-error" class="has-error empty-field-error arial font-bold">Please Check the terms and conditions.</label>'
//               )
//             : '';

//         return false;
//     }

//     return true;
// });

// $checkboxInput.change(() => {
//     const max = 3;

//     if ($('.checkbox-opt.resort-opt:checked').length === max) {
//         $checkboxInput.attr('disabled', 'disabled');
//         $('.checkbox-opt.resort-opt:checked').removeAttr('disabled');
//     } else {
//         $checkboxInput.removeAttr('disabled');
//     }
// });

// // form elements references
// const $countrySelector = $('select[name="country"]');
// const $subscribeLabel = $('.form-label[for="subscribe"]');

// $subscribeLabel.text($subscribeLabel.data('normal'));

// $countrySelector.on('change', event => {
//     const countryId = event.target.value;

//     $subscribeLabel.text($subscribeLabel.data('normal'));

//     if (countryId === 'CA') {
//         $subscribeLabel.html($subscribeLabel.data('canada'));
//     }
// });

// $(document).ready(() => {
//     if ($landlineNumber.val()) {
//         $validPhone.removeAttr('required');
//         $validPhone.val($landlineNumber.val());
//         $mobileNumber.trigger('blur');
//         $validPhone.trigger('blur');
//     }

//     if ($mobileNumber.val()) {
//         $validPhone.removeAttr('required');
//         $landlineNumber.trigger('blur');
//         $validPhone.val($mobileNumber.val());
//         $validPhone.trigger('blur');
//     }
//     $('[name=country]').on('change', function() {
//         const selectedCountry = $(this).val();

//         callingCodesObj.countryCodes.map(function(index) {
//             if (selectedCountry === index.code) {
//                 $('span.countryCode').html(index.dial_code);
//             }
//         });
//     });
// });
